import React, { useEffect, useState } from 'react';
import { Button, Layout, Menu, theme } from 'antd';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { authLayoutMenu } from "../../constants/menuItems";
import { LogoutOutlined } from '@ant-design/icons';
import { clearLocalStorage, getLocalStorage } from '../../helpers/localstorage';
import { getBmdCities } from '../../helpers/getRefs';
const { Header, Content, Sider } = Layout;
const siderStyle = {
    overflow: 'auto',
    height: '100vh',
    position: 'fixed',
    insetInlineStart: 0,
    top: 0,
    bottom: 0,
    scrollbarWidth: 'thin',
    scrollbarColor: 'unset',
    zIndex: 999
};

const App = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const cities = getLocalStorage("bmdCities") || []
    const [selectedKey, setSelectedKey] = useState('');
    const [collapsed, setCollapsed] = useState(false);
    const user = getLocalStorage("auth")?.user
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const items = authLayoutMenu.filter((el) => el.allowedRoles.includes(user?.role)).map((el, _) => ({
        key: el.link,
        icon: React.createElement(el.icon),
        label: el.children ? el.label : <Link to={el.link}>{el.label}</Link>,
        ...(
            el.children?.length && {
                children: el.children.filter((el) => el.allowedRoles.includes(user?.role)).map((child) => ({
                    key: child.link,
                    icon: child.icon ? React.createElement(child.icon) : null,
                    label: <Link to={child.link}>{child.label}</Link>,
                }))
            }
        )
    }));

    const logout = () => {
        clearLocalStorage()
        navigate('/login')
    }

    useEffect(() => {
        console.clear()
        console.log(window.innerWidth)
        if (window.innerWidth <= 425) {
            setCollapsed(true)
        }
        setSelectedKey(location.pathname);
        if (!cities?.length) {
            getBmdCities()
        }
    }, [cities.length, location]);

    return (
        <Layout hasSider>
            <Sider style={siderStyle} collapsible collapsed={collapsed} onCollapse={(value) => {
                if (window.innerWidth > 425)
                    setCollapsed(value)
            }}>
                <div className="demo-logo-vertical" />
                <Menu
                    theme="dark"
                    mode="inline"
                    selectedKeys={selectedKey}
                    items={items}
                />
            </Sider>
            <Layout
                style={{
                    marginInlineStart: collapsed ? 80 : 200,
                    overflowX: "hidden",
                    width: "200%"
                }}
            >
                <Header
                    style={{
                        padding: 0,
                        background: colorBgContainer,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingInline: "20px"
                    }}
                >
                    <span>{user?.name}:{user?.role}</span>
                    <Button
                        onClick={logout}
                    >
                        <LogoutOutlined />
                    </Button>
                </Header>
                <Content
                    style={{
                        margin: '24px 16px 0',
                        overflow: 'initial',
                        background: "#c0bfc4 !important"
                    }}
                >
                    <div
                        style={{
                            padding: 24,
                            textAlign: 'center',
                            background: "#f5f5f5 !important"
                        }}
                    >
                        <Outlet />
                    </div>
                </Content>
                {/* <Footer
                    style={{
                        textAlign: 'center',
                    }}
                >
                    Ant Design ©{new Date().getFullYear()} Created by Ant UED
                </Footer> */}
            </Layout>
        </Layout>
    );
};
export default App;